
/* global require, jQuery, Promise, selfAddressed */

(function (factory) {
    if (typeof require == 'function') {
        require('script!../node_modules/jquery/dist/jquery.min.js');
        require('script!../node_modules/promise-polyfill/promise.js');
        require('script!../node_modules/self-addressed/dist/self-addressed.js');
    }

    factory(window, document, jQuery.noConflict(true), selfAddressed, Promise);
} (function (window, document, $, selfAddressed, Promise) {
    "use strict";

    function log(msg){
        if (!window.console || !window.console.log){
            return;
        }

        console.log(["*** contestlib.js", msg].join(" - "));
    }

    var contestlib = {};

    contestlib.contestReady = false;

    // These are set from host message
    contestlib.parentSrc = null;
    contestlib.contestType = null;
    contestlib.showHomeButton = false;
    contestlib.gigyaEnabled = false;

    contestlib.inIframe = function () {
        try {
            return window.self !== window.top;
        } catch (e) {
            return true;
        }
    };

    contestlib.getCookie = function (cookieName) {
        return new Promise(function (resolve, reject) {
            if (contestlib.inIframe()) {
                if (!contestlib.parentSrc) {
                    reject("contestlib parentSrc not set");
                } else {
                    var data = {};
                    data.funcName = "getCookie";
                    data.params = {};
                    data.params.name = cookieName;
                    selfAddressed(mailman, window.parent, data).then(function (response) {
                        resolve(response.params.value);
                    });
                }
            } else {
                resolve(getCookie(cookieName));
            }
        });
    };

    contestlib.removeCookieOnFullDomain = function (name) {
        var date = new Date(-1);
        var expires = "; expires=" + date.toGMTString();
        var domain = window.location.hostname.toLowerCase();
        var cookie = name + "=" + expires + domain + "; path=/";

        if (window.location.protocol == "https:" && name.toLowerCase() !== "ent") {
            cookie = cookie + "; SameSite=None; Secure";
        }
        
        document.cookie = cookie;
    };

    contestlib.setCookie = function (cookieName, cookieData, expires, domain) {
        return new Promise(function (resolve, reject) {
            log("setCookie()");
            if (contestlib.inIframe()) {
                if (!contestlib.parentSrc) {
                    log("parentSrc not set");
                } else {
                    var data = {};
                    data.funcName = "setCookie";
                    data.params = {};
                    data.params.name = cookieName;
                    data.params.value = cookieData;
                    data.params.expires = expires;
                    data.params.domain = domain;
                    selfAddressed(mailman, window.parent, data).then(function (response) {
                        resolve();
                    });
                }

                // Set local cookie for Stickyfish
                setCookie(cookieName, cookieData, expires);
                resolve();
            } else {
                setCookie(cookieName, cookieData, expires);
                resolve();
            }
        });
    };

    contestlib.getShareLink = function () {
        return new Promise(function (resolve, reject) {
            if (contestlib.inIframe()) {
                if (!contestlib.parentSrc) {
                    resolve("");
                } else {
                    var data = {};
                    data.funcName = "getShareLink";
                    data.params = {};
                    selfAddressed(mailman, window.parent, data).then(function (response) {
                        resolve(response.params.shareLink);
                    });
                }
            } else {
                resolve("");
            }
        });
    };

    contestlib.resize = function (height, width) {
        log("resize()");
        if (contestlib.inIframe()) {
            if (!contestlib.parentSrc) {
                log("parentSrc not set");
            } else {
                var data = {};
                data.funcName = "resize";
                data.params = {};
                data.params.iframeHeight = height;
                data.params.iframeWidth = width;
                selfAddressed(mailman, window.parent, data);
            }
        }
        // don't do any sizing if not in frame
    };

    contestlib.getQueryStringParameter = function (variable) {
        return new Promise(function (resolve, reject) {
            if (contestlib.inIframe()) {
                if (!contestlib.parentSrc) {
                    reject("contestlib parentSrc not set");
                } else {
                    var data = {};
                    data.funcName = "getQueryStringParameter";
                    data.params = {};
                    data.params.variable = variable;
                    selfAddressed(mailman, window.parent, data).then(function (response) {
                        resolve(response.params.value);
                    });
                }
            } else {
                return getQueryVariable(variable);
            }
        });
    };

    contestlib.logout = function(bSkipNotify){

        log("logging out of DI...");

        if (window.digitalIvy && window.digitalIvy.ssoIntegration){
           return window.digitalIvy.ssoIntegration.logout(bSkipNotify);
        } else {
            return contestlib.setCookie("ENT", "", -1)
                .then((res) => contestlib.setCookie("ENT2", "", -1))
                .then((res) => contestlib.setCookie("tl_ugc", "", -1))
                .catch((err) => contestlib.setCookie("tl_ugc", "", -1));
        }
    };

    contestlib.sendMessage = function(msg){
        if (contestlib.inIframe()){
            selfAddressed(mailman, window.parent, msg);
        } else {
            log("ignoring sendMessage() since not in iFrame...");
        }
    };

    function extend() {
        for (var i = 1; i < arguments.length; i++) {
            for (var key in arguments[i]) {
                if (arguments[i].hasOwnProperty(key)) {
                    arguments[0][key] = arguments[i][key];
                }
            }
        }
        return arguments[0];
    }

    // Make location object from url
    function getLocation(href) {
        var l = document.createElement("a");
        l.href = href;
        return l;
    }

    // Origin polyfill for IE/Edge
    function getOrigin(location) {
        if (!location.origin) {
            location.origin = location.protocol + "//"
                + location.hostname
                + (location.port && location.port != '80' && location.port != '443' ? ':' + location.port : '');
        }
        return location.origin;
    }

    function getCookie(name) {
        var value = null;
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) {
                value = c.substring(nameEQ.length, c.length);
            }
        }
        return value;
    }

    function setCookie(name, value, exp) {
        var expires = "";
        if (exp) {
            var date = new Date(exp);
            expires = "; expires=" + date.toGMTString();
        }
        var domain = window.location.hostname.toLowerCase();
        if (domain !== "localhost") {
            domain = domain.split(".");
            domain = domain.slice(domain.length - 2).join(".");
            domain = "; domain=" + domain;
        } else {
            domain = "";
        }

        var cookie = name + "=" + value + expires + domain + "; path=/";

        if (window.location.protocol == "https:" && name.toLowerCase() !== "ent") {
            cookie = cookie + "; SameSite=None; Secure";
        }
        
        document.cookie = cookie;
    }

    function getQueryVariable(variable) {
        var query = window.location.search.substring(1);
        var vars = query.split('&');
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split('=');
            if (window.decodeURIComponent(pair[0]) == variable) {
                return window.decodeURIComponent(pair[1]);
            }
        }
    }

    // Event polyfill for IE
    (function () {
        function CustomEvent(event, params) {
            params = params || { bubbles: false, cancelable: false, detail: undefined };
            var evt = document.createEvent('CustomEvent');
            evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
            return evt;
        }

        CustomEvent.prototype = window.Event.prototype;

        window.CustomEvent = CustomEvent;
    })();

    function removeURLParameter(url, parameter) {
        //prefer to use l.search if you have a location/link object
        var urlparts = url.split('?');
        if (urlparts.length >= 2) {

            var prefix = encodeURIComponent(parameter) + '=';
            var pars = urlparts[1].split(/[&;]/g);

            //reverse iteration as may be destructive
            for (var i = pars.length; i-- > 0;) {
                //idiom for string.startsWith
                if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                    pars.splice(i, 1);
                }
            }

            url = urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : "");
            return url;
        } else {
            return url;
        }
    }

    function getParentUrl(shareLink, linkOld) {
        // remove contestOrigin from old link, and add remainder as query string "tdpath"
        var pathname = getLocation(linkOld).pathname;

        shareLink = removeURLParameter(shareLink, "tdpath");

        var parentUrl = modifyUrl(shareLink, null, ["tdpath=" + encodeURIComponent(pathname)]);

        return parentUrl;
    }

    function rewriteLinks() {
        log("rewriteLinks()");
        if (contestlib.inIframe()) {
            log("getShareLink() called.");
            contestlib.getShareLink().then(function (shareLink) {
                log("rewriting the links.");
                var linkOld;
                // todo get via host, which got via api
                if (contestlib.contestType != 3) {
                    $('#navigation').find('a').each(function (i) {
                        linkOld = $(this).attr('href');
                        if (linkOld !== undefined) {
                            if (linkOld !== '#' && linkOld !== '') {
                                $(this).attr({ href: getParentUrl(shareLink, linkOld), target: '_parent' });
                            }
                        }
                    });
                }
                //TODO: This did also have '#container-content' as part of the selector, but the method is then rewriting URLS that customers
                //enter into their own contest content.  We need to add a classname to our own links so we can tell them apart,
                //then we can target our own links for rewriting and leave the client links alone
                $('#header').find('a').not('.social-controls a, .Submit-agreement a, #captcha a').each(function (i) {
                    linkOld = $(this).attr('href');
                    if (linkOld !== undefined) {
                        if (linkOld.indexOf('#') === -1 && linkOld !== '' && linkOld.indexOf('asp3/') === -1) {
                            $(this).attr({ href: getParentUrl(shareLink, linkOld), target: '_parent' });
                        }
                    }
                });
                // rewrite Contact US link
                $('#container-footer').find('a').each(function (i) {
                    linkOld = $(this).attr('href');
                    if (linkOld !== undefined) {
                        if (linkOld.indexOf('ContactUs') !== -1) {
                            $(this).attr({ href: getParentUrl(shareLink, linkOld), target: '_parent' });
                        }
                    }
                });
                // Social Controls Stickyfish Rewrite
                $('#container-content').find('.social-controls a').each(function (i) {
                    linkOld = $(this).attr('href');
                    if (linkOld !== undefined) {
                        if (linkOld !== '#' && linkOld !== '') {
                            $(this).attr({ href: getParentUrl(shareLink, linkOld), target: '_parent' });
                        }
                    }
                });
            });
        }
    }

    function modifyUrl(originalUrl, addToUrl, arrAddToQString) {
        var urlSplit = originalUrl.split("?"),
            baseUrl = urlSplit[0],
            arrQString = [];

        if (urlSplit.length > 1) {
            arrQString = urlSplit[1].split("&");
        }

        if (arrAddToQString && arrAddToQString.length > 0) {
            arrQString = arrQString.concat(arrAddToQString);
        }

        if (addToUrl) {
            // add ending / if not there
            if (baseUrl.indexOf('/', baseUrl.length - 1) === -1) {
                baseUrl = baseUrl + '/';
            }
            baseUrl = baseUrl + addToUrl;
        }

        if (arrQString && arrQString.length > 0) {
            baseUrl = [baseUrl, arrQString.join("&")].join("?");
        }

        return baseUrl;
    }

    function mailman(address, msg) {
        address.postMessage(msg, contestlib.parentSrc);
    }

    function hostLibReady(event){
        var config = event.data.payload;

        contestlib = extend(contestlib, config.params);

        // Send Handshake
        var data = {};
        data.funcName = "contestReady";
        data.params = {};
        selfAddressed(mailman, window.parent, data);

        if (!contestlib.contestReady) {
            contestlib.contestReady = true;
            //don't rewrite button links if this is gigya SSO
            if (!window.digitalIvy || !window.digitalIvy.ssoIntegration){
                rewriteLinks();
            }
            var contestReadyEvent = new CustomEvent('contestReady');
            document.dispatchEvent(contestReadyEvent);
        }
    }

    function receiveMessage(event) {
        var origin = event.origin || event.originalEvent.origin, // For Chrome, the origin property is in the event.originalEvent object.
            letter = selfAddressed(event.data),
            hostLocation = null,
            hostOrigin = null,
            params = null;

        //not a msg for us? then bail out.
        if (!letter || (!letter.funcName && !letter.msgID)){
            return;
        }

        //unify the message ID
        if (!letter.msgID && letter.funcName){
            letter.msgID = letter.funcName;
        } else if (!letter.msgID){
            letter.msgID = "";
        }

        hostLocation = getLocation(contestlib.parentSrc);
        hostOrigin = getOrigin(hostLocation);

        if (origin !== hostOrigin && letter.msgID !== "hostReady") {
            return;
        }

        log(letter.msgID);

        switch(letter.msgID){
            case "setCookie":
                // Set local cookie
                params = letter.params;
                setCookie(params.name, params.value, params.expires);
                break;
            case "reload":
                window.location.reload();
                break;
            case "hostReady":
                hostLibReady(event);
                break;
            case "hostlib-sso-login":
                if (window.digitalIvy.ssoIntegration) {
                    window.digitalIvy.ssoIntegration.loginAcrossIFrame();
                }
                break;
            case "hostlib-sso-logout":
                if (window.digitalIvy.ssoIntegration) {
                    contestlib.logout(true);
                    window.digitalIvy.ssoIntegration.logoutAcrossIFrame();
                }
                break;
            case "see-gigya-enabled":
                if (window.digitalIvy.ssoIntegration) {
                    contestlib.gigyaEnabled = letter.data;
                    log("see-gigya-enabled: " + contestlib.gigyaEnabled);
                }
                break;
            default:
                return;
        }
    }

    window.addEventListener("message", receiveMessage, false);

    window.contestlib = contestlib;
}));


//////////////////
// WEBPACK FOOTER
// ./contest/contestlib.js
// module id = 0
// module chunks = 0